module.exports = __webpack_public_path__ + "static/media/completePageLogo_4x.f9481bb8.png";